// extracted by mini-css-extract-plugin
export default {"history":"index_history__HKvd8"};